import React from 'react';
import Auth from '../components/Auth';
import '../css/Home.css';

function Home() {
  return (
    <Auth>
      {({ nombreUsuario, isAdmin, handleLogout }) => (
        <div className="home-container">
          <div className="home-welcome-section">
            <h3 className="home-welcome-message">Bienvenido {nombreUsuario}</h3>
            <button className="home-button" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
  
          <h2 className="home-title">Gestión de la documentación pendiente de los cursos</h2>
  
          <ul className="home-ul">
            <li className="home-li">
              <a href="/documentacion">Documentación necesaria</a>
            </li>
            <li className="home-li">
              <a href="/gestion">Gestión de los cursos</a>
            </li>
            <li className="home-li">
              <a href="/llamadas">Llamadas</a>
            </li>
          </ul>
  
          {isAdmin && (
            <div className="home-create-user-section">
              <a href="/register">
                <button className="home-button">Crear Usuario</button>
              </a>
            </div>
          )}
        </div>
      )}
    </Auth>
  );
  
}

export default Home;
